import React, { useRef } from 'react';
import { Options as HighChartOptions } from 'highcharts/highcharts';

import { ChartContent } from '../../Chart';
import FlexCentered from '../../Common/FlexCentered';

const GaugeView = ({ chartOptions }: { chartOptions: HighChartOptions }) => {
  const chartRef = useRef<any>();

  return (
    <FlexCentered style={{ height: '100%', width: '100%' }}>
      <ChartContent options={chartOptions} chartRef={chartRef} />
    </FlexCentered>
  );
};

export default GaugeView;
